export const formatIndianCurrency = (number: any) => {
  if (number || number === 0) {
    if (number >= 1_00_00_000) return `${(number / 1_00_00_000).toFixed(1)}Cr`;
    if (number >= 1_00_000) return `${(number / 1_00_000).toFixed(1)}L`;
    if (number >= 1_000) return `${(number / 1_000).toFixed(1)}K`;
    return number.toString();
  }
  return null;
};
